module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "counter-wrapper"
  }, [_c('div', {
    staticClass: "counter"
  }, [_vm._v("\n    " + _vm._s(_vm.count) + "\n  ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$store.commit('INCREMENT')
      }
    }
  }, [_vm._v("Increment")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$store.commit('DECREMENT')
      }
    }
  }, [_vm._v("Decrement")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        _vm.$store.dispatch('incrementAsync')
      }
    }
  }, [_vm._v("Increment Async")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e77c5cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Counter.vue
// module id = 263
// module chunks = 1